(() => {
  const roots = document.querySelectorAll('[data-shift-platform-root]');
  if (!roots.length) return;

  const BOOKS = [
    {
      id: 'ex',
      title: '7 napos program',
      label: '7 napos interaktív útvonal',
      desc: 'A teljes, napokra bontott The Shift program vezetett gyakorlatokkal.',
      cover: '7 NAPOS<br>PROGRAM',
      coverVariant: 'wine',
      minimumLevel: 'basic',
      readerHeading: 'A 7 napos program',
      unitLabel: 'nap',
      lessons: [
        {
          title: 'Energia visszahívása',
          subtitle: 'Megállítod, hogy minden gondolatod körülötte forogjon.',
          copy: 'Az első nap célja nem az, hogy elnyomd az érzéseidet, hanem hogy visszahívd azt az energiát, amit teljesen az ő reakciójához kötöttél. Ma nem döntesz, nem írsz pánikból, nem keresel jeleket. Csak visszatérsz magadhoz.',
          task: 'Írd le őszintén: miben adtad át neki az erődet az elmúlt napokban? Hol figyelted túl őt?'
        },
        {
          title: 'Hiányból vonzásba',
          subtitle: 'A pánik helyett belső stabilitásba lépsz.',
          copy: 'A hiány állapota gyakran még több hiányt hoz. Ma azt figyeled meg, mikor kapcsol be benned a sürgetés, és hogyan tudsz egy nyugodtabb, nőiesebb, erősebb állapotba visszalépni.',
          task: 'Fejezd be a mondatot legalább ötször: Akkor is értékes vagyok, ha...'
        },
        {
          title: 'Gondolati lenyomat',
          subtitle: 'Nem kapaszkodsz, hanem tisztább érzelmi képet tartasz.',
          copy: 'A harmadik nap fókusza az, milyen képet tartasz magadról és rólatok. Nem görcsös elképzelés, hanem tiszta, nyugodt, erős belső kép.',
          task: 'Milyen érzést szeretnél újra felébreszteni benne? Írd le részletesen, de ne hiányból.'
        },
        {
          title: 'Vágyfókusz',
          subtitle: 'Nem bizonyítasz, hanem újra vonzó állapotba lépsz.',
          copy: 'Ma azt építed, hogy ne az elvesztés félelméből, hanem a saját vonzerődből működj. A cél: ne neki bizonyíts, hanem magadnak térj vissza.',
          task: 'Írd le: milyen nő voltál akkor, amikor a legerősebben vonzódott hozzád?'
        },
        {
          title: 'Éjszakai ráhangolódás',
          subtitle: 'Lefekvés előtti fókusz a nyugodt kapcsolódásra.',
          copy: 'Este a tudat csendesebb. A mai gyakorlatban nem kényszerítesz semmit, csak belépsz abba az érzésbe, mintha már nem kellene kapaszkodnod.',
          task: 'Lefekvés előtt írd le háromszor: Elengedem a pánikot, és visszatérek a saját erőmbe.'
        },
        {
          title: 'Vonzási mező stabilizálása',
          subtitle: 'Nem esel vissza a várakozó mintába.',
          copy: 'A hatodik nap arról szól, hogyan tartsd meg azt az állapotot, amelyben már nem az ő minden mozdulata határoz meg.',
          task: 'Milyen három dolgot teszel holnap kizárólag magadért?'
        },
        {
          title: 'Visszahívó rituálé',
          subtitle: 'A folyamat lezárása egy célzott manifesztációs fókuszban.',
          copy: 'A hetedik nap nem lezárás, hanem irányba állítás. Nem üldözöl. Nem bizonyítasz. Tiszta belső szándékot tartasz.',
          task: 'Írd le a végső szándékodat egy mondatban, félelem és kényszer nélkül.'
        }
      ]
    },
    {
      id: 'fast',
      title: '24 órás gyorsítás',
      label: '24 órás interaktív protokoll',
      desc: 'Fókuszált gyorsító gyakorlatok a belső állapotod rendezéséhez.',
      cover: '24 ÓRÁS<br>GYORSÍTÁS',
      coverVariant: 'blush',
      minimumLevel: 'fast',
      readerHeading: 'A 24 órás gyorsítás',
      unitLabel: 'lépés',
      lessons: [
        {
          title: 'Azonnali megállítás',
          subtitle: 'Leállítod a sürgetést, és visszaveszed a figyelmedet.',
          copy: 'A gyorsítás első része nem arról szól, hogy erősebben próbálkozz, hanem arról, hogy megszakítsd azt az automatikus állapotot, amelyben minden figyelmed a másik reakciójára kerül.',
          task: 'Írd le röviden: mit próbálsz most sürgetni, és mit tudsz ebből a következő 24 órára elengedni?'
        },
        {
          title: 'Belső fókusz',
          subtitle: 'A hiány helyett azt erősíted, amit valóban meg szeretnél élni.',
          copy: 'A következő lépésben különválasztod a félelemből születő gondolatokat attól a kapcsolódástól, amelyre valójában vágysz. A cél egy nyugodtabb és tisztább belső kép.',
          task: 'Milyen érzést szeretnél megélni ebben a kapcsolatban, függetlenül attól, hogy a másik most mit tesz?'
        },
        {
          title: 'Stabilizálás',
          subtitle: 'A nap folyamán megtartod a választott állapotodat.',
          copy: 'A stabilizálás lényege, hogy ne minden új gondolat vagy külső jel billentsen ki. Nem kell tökéletesen érezned magad; elég, ha újra és újra visszatérsz ugyanahhoz a belső ponthoz.',
          task: 'Mi az a három konkrét dolog, amivel ma vissza tudsz térni magadhoz?'
        },
        {
          title: 'Esti lezárás',
          subtitle: 'Lezárod a napot, és nem viszed tovább a feszültséget.',
          copy: 'Az utolsó részben összegzed, mit vettél észre magadon. Nem eredményt kényszerítesz, hanem rögzíted azt az állapotot, amelyet tovább szeretnél vinni.',
          task: 'Mi változott benned a mai nap során, és mit szeretnél ebből holnap is megtartani?'
        }
      ]
    },
    {
      id: 'journal',
      title: 'The Shift Journal',
      label: 'Interaktív manifesztációs napló',
      desc: 'Vezetett naplófeladatok, esti fókuszok és belső tisztázó kérdések.',
      cover: 'THE<br>SHIFT<br>JOURNAL',
      coverVariant: 'journal',
      minimumLevel: 'fast',
      readerHeading: 'The Shift Journal',
      unitLabel: 'bejegyzés',
      lessons: [
        {
          title: 'Reggeli fókusz',
          subtitle: 'Tiszta indulópont a napodra.',
          copy: 'A napló célja, hogy ne automatikusan a másik ember reakciójához kapcsolódj, hanem először a saját állapotodat tedd rendbe.',
          task: 'Ma milyen állapotból szeretnék kapcsolódni?'
        },
        {
          title: 'Esti lezárás',
          subtitle: 'Visszaveszed az energiádat lefekvés előtt.',
          copy: 'Este sokszor felerősödik a hiány. A lezáró kérdés segít, hogy ne ezzel aludj el.',
          task: 'Mit engedek el ma este, amit nem kell tovább cipelnem?'
        }
      ]
    }
  ];

  roots.forEach(initPlatform);

  function initPlatform(root) {
    const configEl = root.querySelector('[data-shift-platform-config]');
    const config = configEl ? JSON.parse(configEl.textContent || '{}') : {};
    const key = `shift_platform_${config.sectionId || 'default'}`;

    const state = {
      activeBook: localStorage.getItem(`${key}_activeBook`) || 'ex',
      openLesson: Number(localStorage.getItem(`${key}_openLesson`) || 0),
      session: getSavedSession(),
      bootstrap: null,
      remoteReady: false
    };

    const bookGrid = root.querySelector('[data-book-grid]');
    const libraryHome = root.querySelector('[data-library-home]');
    const reader = root.querySelector('[data-reader]');
    const lessonsEl = root.querySelector('[data-lessons]');
    const embedded = root.querySelector('[data-embedded-platform]');
    const frame = root.querySelector('[data-platform-frame]');

    if (config.platformMode === 'embedded' && embedded && frame) {
      frame.src = config.embeddedUrl || '';
    }

    initAuthGate();
    renderBooks();
    updateContinueCard();
    bindGlobal();

    function getSavedSession() {
      try { return JSON.parse(localStorage.getItem(`${key}_session`) || 'null'); }
      catch(e) { return null; }
    }

    function saveSession(session) {
      localStorage.setItem(`${key}_session`, JSON.stringify(session));
      state.session = session;
    }

    function initAuthGate() {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token') || params.get('activation') || params.get('access') || '';
      const emailFromUrl = params.get('email') || '';
      const hasSession = Boolean(state.session && state.session.email);

      if (hasSession) {
        unlockPlatform();
        loadRemoteBootstrap();
        return;
      }

      lockPlatform();
      bindAuthForms();

      const resetToken = params.get('reset') || '';

      if (resetToken) {
        showResetMode(resetToken);
      } else if (token) {
        verifyActivationToken(token, emailFromUrl);
      } else if (params.has('login') || params.get('mode') === 'login') {
        showLoginMode(emailFromUrl);
      } else {
        showActivationMode(false);
      }
    }

    function lockPlatform() {
      root.classList.add('is-locked');
      root.querySelector('[data-auth-gate]')?.removeAttribute('hidden');
    }

    function unlockPlatform() {
      root.classList.remove('is-locked');
      root.querySelector('[data-auth-gate]')?.setAttribute('hidden', '');
    }

    function bindAuthForms() {
      const activateForm = root.querySelector('[data-auth-activate]');
      const loginForm = root.querySelector('[data-auth-login]');

      activateForm?.addEventListener('submit', async event => {
        event.preventDefault();
        const password = root.querySelector('[data-auth-password]')?.value || '';
        const confirmPassword = root.querySelector('[data-auth-confirm]')?.value || '';

        if (password.length < 8) return showAuthError('data-auth-error', 'A jelszó legalább 8 karakter legyen.');
        if (password !== confirmPassword) return showAuthError('data-auth-error', 'A két jelszó nem egyezik.');

        hideAuthError('data-auth-error');
        const submitButton = activateForm.querySelector('button[type="submit"]');
        setButtonBusy(submitButton, true, 'Aktiválás…');
        try {
          const params = new URLSearchParams(window.location.search);
          const token = params.get('token') || params.get('activation') || params.get('access') || '';
          const data = await platformApi('/activation/complete', {
            method: 'POST',
            auth: false,
            body: { token, password, confirmPassword }
          });
          saveSession(data.session);
          applyBootstrap(data.bootstrap);
          cleanActivationParams();
          unlockPlatform();
        } catch (error) {
          showAuthError('data-auth-error', error.message || 'Nem sikerült aktiválni a fiókot. Próbáld újra.');
        } finally {
          setButtonBusy(submitButton, false, 'Fiók aktiválása');
        }
      });

      loginForm?.addEventListener('submit', async event => {
        event.preventDefault();
        const email = root.querySelector('[data-login-email]')?.value.trim().toLowerCase() || '';
        const password = root.querySelector('[data-login-password]')?.value || '';

        if (!email) return showAuthError('data-login-error', 'Hiányzik a belépési e-mail-cím.');
        if (!password) return showAuthError('data-login-error', 'Add meg a jelszavad.');

        hideAuthError('data-login-error');
        const submitButton = loginForm.querySelector('button[type="submit"]');
        setButtonBusy(submitButton, true, 'Belépés…');
        try {
          const data = await platformApi('/login', {
            method: 'POST',
            auth: false,
            body: { email, password }
          });
          saveSession(data.session);
          applyBootstrap(data.bootstrap);
          cleanActivationParams();
          unlockPlatform();
        } catch (error) {
          showAuthError('data-login-error', error.message || 'Nem sikerült belépni. Ellenőrizd a jelszavad.');
        } finally {
          setButtonBusy(submitButton, false, 'Belépek a könyvtárba');
        }
      });

      root.querySelector('[data-forgot-open]')?.addEventListener('click', () => {
        showForgotMode(root.querySelector('[data-login-email]')?.value || '');
      });

      root.querySelector('[data-forgot-cancel]')?.addEventListener('click', () => {
        showLoginMode(root.querySelector('[data-forgot-email]')?.value || '');
      });

      const forgotForm = root.querySelector('[data-auth-forgot]');
      forgotForm?.addEventListener('submit', async event => {
        event.preventDefault();
        const email = root.querySelector('[data-forgot-email]')?.value.trim().toLowerCase() || '';
        if (!email || !email.includes('@')) {
          return showAuthError('data-forgot-error', 'Add meg az e-mail-címedet.');
        }

        hideAuthError('data-forgot-error');
        const submitButton = forgotForm.querySelector('button[type="submit"]');
        setButtonBusy(submitButton, true, 'Küldés…');
        try {
          await platformApi('/forgot-password', { method: 'POST', auth: false, body: { email } });
          // The backend answers identically whether or not the account exists,
          // so this message must not imply that it does.
          root.querySelector('[data-forgot-sent]')?.removeAttribute('hidden');
        } catch (error) {
          showAuthError('data-forgot-error', error.message || 'Nem sikerült elküldeni a linket. Próbáld újra.');
        } finally {
          setButtonBusy(submitButton, false, 'Jelszóbeállító link kérése');
        }
      });

      const resetForm = root.querySelector('[data-auth-reset]');
      resetForm?.addEventListener('submit', async event => {
        event.preventDefault();
        const password = root.querySelector('[data-reset-password]')?.value || '';
        const confirmPassword = root.querySelector('[data-reset-confirm]')?.value || '';

        if (password.length < 8) return showAuthError('data-reset-error', 'A jelszó legalább 8 karakter legyen.');
        if (password !== confirmPassword) return showAuthError('data-reset-error', 'A két jelszó nem egyezik.');

        hideAuthError('data-reset-error');
        const submitButton = resetForm.querySelector('button[type="submit"]');
        setButtonBusy(submitButton, true, 'Mentés…');
        try {
          const data = await platformApi('/reset-password', {
            method: 'POST',
            auth: false,
            body: { token: state.resetToken || '', password, confirmPassword }
          });
          saveSession(data.session);
          applyBootstrap(data.bootstrap);
          cleanActivationParams();
          unlockPlatform();
        } catch (error) {
          showAuthError('data-reset-error', error.message || 'Nem sikerült beállítani a jelszót. Kérj új linket.');
        } finally {
          setButtonBusy(submitButton, false, 'Jelszó mentése');
        }
      });
    }

    async function verifyActivationToken(token, fallbackEmail) {
      setText('[data-auth-title]', 'Állítsd be a jelszavad');
      setText('[data-auth-copy]', 'A rendelési e-mail-címet automatikusan beolvassuk az aktiváló linkből.');
      setText('[data-auth-email-preview]', 'rendelés ellenőrzése…');
      const activateForm = root.querySelector('[data-auth-activate]');
      const submitButton = activateForm?.querySelector('button[type="submit"]');
      activateForm?.removeAttribute('hidden');
      setButtonBusy(submitButton, true, 'Ellenőrzés…');
      try {
        await platformApi(`/activation/verify?token=${encodeURIComponent(token)}`, { auth: false });
        showActivationMode(true);
        setButtonBusy(submitButton, false, 'Fiók aktiválása');
      } catch (error) {
        showActivationMode(false);
        showAuthError('data-auth-error', error.message || 'Az aktiváló link érvénytelen vagy lejárt.');
      }
    }

    async function platformApi(path, options = {}) {
      const base = String(config.apiBaseUrl || root.dataset.apiBase || '').replace(/\/$/, '');
      if (!base) throw new Error('Hiányzik a backend URL.');
      const headers = { 'Content-Type': 'application/json' };
      if (options.auth !== false) {
        const token = state.session?.token;
        if (!token) throw new Error('Bejelentkezés szükséges.');
        headers.Authorization = `Bearer ${token}`;
      }
      const response = await fetch(`${base}/api/shopify-platform${path}`, {
        method: options.method || 'GET',
        headers,
        body: options.body ? JSON.stringify(options.body) : undefined,
        cache: 'no-store'
      });
      let data = {};
      try { data = await response.json(); } catch(e) {}
      if (!response.ok) {
        throw new Error(data.message || data.error || 'Szerverhiba történt.');
      }
      return data;
    }

    async function loadRemoteBootstrap() {
      if (!state.session?.token) return;
      try {
        const data = await platformApi('/bootstrap');
        let bootstrap = data.bootstrap || data;
        if (!bootstrap.program?.started_at) {
          await platformApi('/program/start', { method: 'POST' });
          const refreshed = await platformApi('/bootstrap');
          bootstrap = refreshed.bootstrap || refreshed;
        }
        applyBootstrap(bootstrap);
      } catch (error) {
        console.error('SHIFT_PLATFORM_BOOTSTRAP_FAILED', error);
      }
    }

    function applyBootstrap(bootstrap) {
      if (!bootstrap) return;
      state.bootstrap = bootstrap;
      state.remoteReady = true;

      const baseLessons = (BOOKS.find(item => item.id === 'ex')?.lessons || []).slice();
      const exBook = BOOKS.find(item => item.id === 'ex');
      if (exBook && Array.isArray(bootstrap.lessons) && bootstrap.lessons.length) {
        exBook.lessons = bootstrap.lessons.slice(0, 7).map((lesson, index) => ({
          title: lesson.title || `${index + 1}. nap`,
          subtitle: `${lesson.phase || 'The Shift'}${lesson.duration ? ' · ' + lesson.duration : ''}`,
          copy: `${lesson.intro || ''}${lesson.affirmation ? '\n\nMegerősítés: ' + lesson.affirmation : ''}`.trim(),
          task: (baseLessons[index]?.task) || 'Írd le a mai lecke legfontosabb felismerését és azt, mit fogsz ma másképp csinálni.'
        }));
      }

      syncStorageFromBootstrap(bootstrap);
      renderBooks();
      updateMentorStatus();
      updateCreditLinks();
      updateContinueCard();
      if (reader && !reader.hasAttribute('hidden')) renderReader();
    }

    function syncStorageFromBootstrap(bootstrap) {
      const storage = getStorage();
      storage.ex = storage.ex || { lessons: {} };
      const journalsByDay = {};
      (bootstrap.journals || []).forEach(entry => {
        if (entry.lesson_day && entry.content && !journalsByDay[entry.lesson_day]) {
          journalsByDay[entry.lesson_day] = entry.content;
          return;
        }

        if (!entry.lesson_day && entry.content && entry.title) {
          const book = BOOKS.find(item => item.id !== 'ex' && String(entry.title).startsWith(`${item.title} – `));
          const match = String(entry.title).match(/–\s*(\d+)\./);
          if (book && match) {
            const index = Number(match[1]) - 1;
            storage[book.id] = storage[book.id] || { lessons: {} };
            storage[book.id].lessons[index] = storage[book.id].lessons[index] || {};
            storage[book.id].lessons[index].answer = entry.content;
            storage[book.id].lessons[index].remoteId = entry.id;
          }
        }
      });
      (bootstrap.progress || []).forEach(row => {
        const index = Number(row.lesson_day || 1) - 1;
        storage.ex.lessons[index] = storage.ex.lessons[index] || {};
        storage.ex.lessons[index].done = Boolean(row.completed);
        const answers = row.answers || {};
        storage.ex.lessons[index].answer = journalsByDay[row.lesson_day] || answers.journal || answers.answer || Object.values(answers)[0] || storage.ex.lessons[index].answer || '';
      });
      setStorage(storage);
    }

    function cleanActivationParams() {
      if (!window.history?.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.delete('token');
      url.searchParams.delete('activation');
      url.searchParams.delete('access');
      url.searchParams.delete('email');
      url.searchParams.delete('login');
      url.searchParams.delete('mode');
      url.searchParams.delete('reset');
      window.history.replaceState({}, document.title, url.toString());
    }

    // --- password recovery -------------------------------------------------
    // The storefront previously had no way back in for a customer who forgot
    // their password: activation only works once, and its grant is consumed.

    function hideAllAuthForms() {
      ['[data-auth-activate]', '[data-auth-login]', '[data-auth-forgot]', '[data-auth-reset]', '[data-auth-success]']
        .forEach(selector => root.querySelector(selector)?.setAttribute('hidden', ''));
    }

    function showForgotMode(prefillEmail) {
      hideAllAuthForms();
      root.querySelector('[data-auth-forgot]')?.removeAttribute('hidden');
      hideAuthError('data-forgot-error');
      root.querySelector('[data-forgot-sent]')?.setAttribute('hidden', '');

      const input = root.querySelector('[data-forgot-email]');
      if (input && prefillEmail) input.value = String(prefillEmail).trim().toLowerCase();

      setText('[data-auth-title]', 'Új jelszó kérése');
      setText('[data-auth-copy]', 'Add meg a vásárláskor használt e-mail-címed, és küldünk egy linket, amivel új jelszót állíthatsz be.');
    }

    function showResetMode(token) {
      hideAllAuthForms();
      root.querySelector('[data-auth-reset]')?.removeAttribute('hidden');
      hideAuthError('data-reset-error');
      state.resetToken = token;

      setText('[data-auth-title]', 'Állíts be új jelszót');
      setText('[data-auth-copy]', 'Válassz egy legalább 8 karakteres jelszót. A link csak egyszer használható fel.');
    }

    function setButtonBusy(button, busy, label) {
      if (!button) return;
      button.disabled = Boolean(busy);
      button.textContent = label;
    }

    function showActivationMode(fromToken) {
      const activateForm = root.querySelector('[data-auth-activate]');
      const loginForm = root.querySelector('[data-auth-login]');
      if (fromToken) activateForm?.removeAttribute('hidden');
      else activateForm?.setAttribute('hidden', '');
      loginForm?.setAttribute('hidden', '');
      root.querySelector('[data-auth-success]')?.setAttribute('hidden', '');

      setText('[data-auth-title]', fromToken ? 'Állítsd be a jelszavad' : 'Aktiváló link szükséges');
      setText('[data-auth-copy]', fromToken
        ? 'A rendelésedet biztonságosan azonosítottuk. Már csak egy jelszót kell választanod.'
        : 'Nyisd meg újra a vásárlás után kapott aktiváló e-mailt. Belépéshez a fiókaktiválás után küldött külön e-mailben lévő gombot használd.'
      );
      setText('[data-auth-email-preview]', fromToken ? 'sikeresen azonosítva' : 'aktiváló e-mail szükséges');
      setText('[data-auth-note]', fromToken
        ? 'A rendelési e-mail-címet és a hozzáférést az aktiváló tokenből olvassuk ki. Jelszót soha nem küldünk e-mailben.'
        : 'A könyvtár csak a vásárláshoz kapcsolódó aktiváló vagy belépési e-mailből nyitható meg.'
      );
    }

    function showLoginMode(email) {
      const normalizedEmail = String(email || '').trim().toLowerCase();
      root.querySelector('[data-auth-activate]')?.setAttribute('hidden', '');
      root.querySelector('[data-auth-success]')?.setAttribute('hidden', '');
      const loginForm = root.querySelector('[data-auth-login]');
      loginForm?.removeAttribute('hidden');

      const emailInput = root.querySelector('[data-login-email]');
      if (emailInput) {
        emailInput.value = normalizedEmail;
        emailInput.readOnly = false;
        emailInput.disabled = false;
        emailInput.setAttribute('autocomplete', 'email');
        emailInput.setAttribute('inputmode', 'email');
        emailInput.setAttribute('placeholder', 'A vásárláskor használt e-mail-cím');
      }

      setText('[data-auth-title]', 'Belépés a könyvtárba');
      setText('[data-auth-copy]', normalizedEmail
        ? 'Az e-mail-címedet automatikusan kitöltöttük. Add meg a jelszavadat a belépéshez.'
        : 'Add meg a vásárláskor használt e-mail-címedet és a korábban beállított jelszavadat.'
      );
      setText('[data-auth-email-preview]', normalizedEmail || 'e-mail-cím és jelszó szükséges');
      setText('[data-auth-note]', normalizedEmail
        ? 'A belépési link a vásárláskor használt e-mail-címhez kapcsolódik.'
        : 'Csak azzal az e-mail-címmel tudsz belépni, amellyel a vásárlás és a fiókaktiválás történt.'
      );

      if (!normalizedEmail) {
        window.setTimeout(() => emailInput?.focus(), 0);
      }
    }

    function showAuthError(selector, message) {
      const el = root.querySelector(`[${selector}]`);
      if (!el) return;
      el.textContent = message;
      el.removeAttribute('hidden');
    }

    function hideAuthError(selector) {
      const el = root.querySelector(`[${selector}]`);
      if (!el) return;
      el.textContent = '';
      el.setAttribute('hidden', '');
    }

    function getStorage() {
      try { return JSON.parse(localStorage.getItem(`${key}_progress`) || '{}'); }
      catch(e) { return {}; }
    }

    function setStorage(data) {
      localStorage.setItem(`${key}_progress`, JSON.stringify(data));
    }

    function levelRank(level) {
      return ({ basic: 1, fast: 2, ai: 3 })[level] || 1;
    }

    function visibleBooks() {
      if (!state.remoteReady) return BOOKS;
      const currentLevel = state.bootstrap?.entitlement?.course_level || 'basic';
      return BOOKS.filter(book => levelRank(currentLevel) >= levelRank(book.minimumLevel));
    }

    function isMentorActive() {
      const entitlement = state.bootstrap?.entitlement || {};
      const activeUntil = entitlement.ai_access_until ? new Date(entitlement.ai_access_until).getTime() : 0;
      return Boolean(
        entitlement.ai_subscription_status === 'active' ||
        activeUntil > Date.now() ||
        Number(state.bootstrap?.dailyRemaining || 0) > 0 ||
        Number(state.bootstrap?.bonusRemaining || 0) > 0
      );
    }

    function localEntryCount(book, storage) {
      return book.lessons.filter((_, index) => {
        const lesson = storage[book.id]?.lessons?.[index];
        return Boolean(lesson?.done || String(lesson?.answer || '').trim());
      }).length;
    }

    function nextLessonIndex(book, storage) {
      const index = book.lessons.findIndex((_, lessonIndex) => !storage[book.id]?.lessons?.[lessonIndex]?.done);
      return index === -1 ? Math.max(0, book.lessons.length - 1) : index;
    }

    function bookMeta(book, storage) {
      const progress = calcProgress(book, storage);
      if (book.id === 'journal') {
        const remoteCount = Number(state.bootstrap?.journals?.length || 0);
        const count = Math.max(remoteCount, localEntryCount(book, storage));
        return {
          text: `${count} bejegyzés`,
          progress,
          action: count > 0 ? 'Folytatás' : 'Megnyitás'
        };
      }

      const started = localEntryCount(book, storage) > 0;
      const nextIndex = nextLessonIndex(book, storage);
      return {
        text: started ? `${nextIndex + 1}. ${book.unitLabel} • ${progress}%` : 'Még nem kezdted el',
        progress,
        action: started ? 'Folytatás' : 'Megnyitás'
      };
    }

    function renderBooks() {
      if (!bookGrid) return;
      const storage = getStorage();
      const books = visibleBooks();
      const count = root.querySelector('[data-book-count]');
      if (count) count.textContent = `${books.length} e-book`;

      bookGrid.innerHTML = books.map(book => {
        const meta = bookMeta(book, storage);
        return `
          <article class="spl-book-card" data-book-card="${book.id}">
            <div class="spl-book-card__cover spl-book-card__cover--${book.coverVariant}" aria-hidden="true">
              <span>The Love Method</span>
              <strong>${book.cover}</strong>
            </div>
            <div class="spl-book-card__body">
              <div class="spl-book-card__top">
                <h3>${escapeHtml(book.title)}</h3>
                <span class="spl-interactive-pill">Interaktív</span>
              </div>
              <p class="spl-book-meta">${escapeHtml(meta.text)}</p>
              <div class="spl-mini-progress" aria-label="Haladás: ${meta.progress}%"><i style="width:${meta.progress}%"></i></div>
              <button type="button" data-open-book="${book.id}">${meta.action}</button>
            </div>
          </article>
        `;
      }).join('');

      if (!books.length) {
        bookGrid.innerHTML = `
          <div class="spl-library-empty">
            <strong>Még nincs e-book a könyvtáradban.</strong>
            <span>A megvásárolt tartalmaid automatikusan itt jelennek meg.</span>
          </div>
        `;
      }

      bookGrid.querySelectorAll('[data-open-book]').forEach(btn => {
        btn.addEventListener('click', () => openBook(btn.dataset.openBook));
      });
    }

    function openBook(bookId) {
      const book = visibleBooks().find(item => item.id === bookId);
      if (!book) return;
      const storage = getStorage();
      state.activeBook = book.id;
      state.openLesson = nextLessonIndex(book, storage);
      localStorage.setItem(`${key}_activeBook`, book.id);
      localStorage.setItem(`${key}_openLesson`, String(state.openLesson));

      libraryHome?.setAttribute('hidden', '');
      embedded?.setAttribute('hidden', '');
      reader?.removeAttribute('hidden');
      renderReader();
      reader?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function renderReader() {
      const books = visibleBooks();
      const book = books.find(item => item.id === state.activeBook) || books[0] || BOOKS[0];
      const storage = getStorage();
      const progress = calcProgress(book, storage);

      setText('[data-reader-title]', book.title);
      setText('[data-reader-desc]', book.desc);
      setText('[data-reader-label]', book.label);
      setHtml('[data-reader-cover]', book.cover);
      setText('[data-reader-heading]', book.readerHeading);
      setText('[data-reader-progress-text]', `${progress}%`);
      const readerCover = root.querySelector('[data-reader-cover]');
      if (readerCover) {
        readerCover.className = `spl-book-cover spl-book-cover--${book.coverVariant}`;
      }
      const progressBar = root.querySelector('[data-reader-progress]');
      if (progressBar) progressBar.style.width = `${progress}%`;

      if (!lessonsEl) return;
      lessonsEl.innerHTML = book.lessons.map((lesson, index) => {
        const done = Boolean(storage[book.id]?.lessons?.[index]?.done);
        const answer = storage[book.id]?.lessons?.[index]?.answer || '';
        const open = index === state.openLesson;
        return `
          <section class="spl-lesson ${open ? 'is-open' : ''} ${done ? 'is-done' : ''}" data-lesson="${index}">
            <button class="spl-lesson__button" type="button" data-toggle-lesson="${index}">
              <span class="spl-day-number">${done ? '✓' : index + 1}</span>
              <span class="spl-lesson__title">
                <strong>${index + 1}. ${escapeHtml(book.unitLabel)} – ${escapeHtml(lesson.title)}</strong>
                <span>${escapeHtml(lesson.subtitle)}</span>
              </span>
              <span class="spl-lesson__chev">${open ? '−' : '+'}</span>
            </button>
            <div class="spl-lesson__panel">
              <div class="spl-lesson-copy">${escapeHtml(lesson.copy)}</div>
              <div class="spl-task">
                <strong>${book.id === 'journal' ? 'Naplóbejegyzés' : 'Interaktív kérdés'}</strong>
                <p class="spl-lesson-copy">${escapeHtml(lesson.task)}</p>
                <textarea data-journal="${index}" placeholder="Ide írd a válaszod...">${escapeHtml(answer)}</textarea>
                <div class="spl-task-actions">
                  <button class="spl-save" type="button" data-save-lesson="${index}">Mentés</button>
                  <button class="spl-done" type="button" data-done-lesson="${index}">${done ? 'Késznek jelölve' : 'Késznek jelölöm'}</button>
                  <button class="spl-ask" type="button" data-ask-lesson="${index}">Kérdezem a Mentort</button>
                </div>
              </div>
            </div>
          </section>
        `;
      }).join('');

      lessonsEl.querySelectorAll('[data-toggle-lesson]').forEach(btn => {
        btn.addEventListener('click', () => {
          state.openLesson = Number(btn.dataset.toggleLesson);
          localStorage.setItem(`${key}_openLesson`, String(state.openLesson));
          renderReader();
        });
      });

      lessonsEl.querySelectorAll('[data-save-lesson]').forEach(btn => {
        btn.addEventListener('click', () => saveLesson(Number(btn.dataset.saveLesson), false));
      });

      lessonsEl.querySelectorAll('[data-done-lesson]').forEach(btn => {
        btn.addEventListener('click', () => saveLesson(Number(btn.dataset.doneLesson), true));
      });

      lessonsEl.querySelectorAll('[data-ask-lesson]').forEach(btn => {
        btn.addEventListener('click', () => openMentor(Number(btn.dataset.askLesson)));
      });

      updateMentorContext();
      updateContinueCard();
      renderBooks();
    }

    async function saveLesson(index, markDone) {
      const book = BOOKS.find(item => item.id === state.activeBook) || BOOKS[0];
      const textarea = root.querySelector(`[data-journal="${index}"]`);
      const answer = textarea ? textarea.value : '';
      const storage = getStorage();
      storage[book.id] = storage[book.id] || { lessons: {} };
      storage[book.id].lessons[index] = storage[book.id].lessons[index] || {};
      storage[book.id].lessons[index].answer = answer;
      if (markDone) storage[book.id].lessons[index].done = true;
      setStorage(storage);
      renderReader();

      if (state.session?.token) {
        try {
          const lessonDay = index + 1;
          if (book.id === 'ex') {
            await platformApi('/progress', {
              method: 'POST',
              body: { lessonDay, answers: { journal: answer }, completed: markDone ? true : undefined, opened: true }
            });
            if (answer.trim()) {
              await platformApi('/journal', {
                method: 'POST',
                body: { lessonDay, title: `${lessonDay}. nap – ${book.lessons[index]?.title || 'Napló'}`, content: answer, shareWithAi: true }
              });
            }
          } else if (answer.trim()) {
            const current = getStorage();
            const remoteId = current[book.id]?.lessons?.[index]?.remoteId;
            const result = await platformApi('/journal', {
              method: 'POST',
              body: {
                id: remoteId || undefined,
                lessonDay: null,
                title: `${book.title} – ${index + 1}. ${book.unitLabel}`,
                content: answer,
                shareWithAi: true
              }
            });
            if (result?.journal?.id) {
              current[book.id] = current[book.id] || { lessons: {} };
              current[book.id].lessons[index] = current[book.id].lessons[index] || {};
              current[book.id].lessons[index].remoteId = result.journal.id;
              setStorage(current);
            }
          }
          loadRemoteBootstrap();
        } catch (error) {
          addMentorMessage('mentor', `A mentés helyben sikerült, de a szerveres mentés most nem ment át: ${error.message || 'ismeretlen hiba'}`);
        }
      }
    }

    function calcProgress(book, storage) {
      if (!book.lessons.length) return 0;
      const done = book.lessons.filter((_, idx) => storage[book.id]?.lessons?.[idx]?.done).length;
      return Math.round((done / book.lessons.length) * 100);
    }

    function updateContinueCard() {
      const books = visibleBooks();
      if (books.length && !books.some(book => book.id === state.activeBook)) {
        state.activeBook = books[0].id;
        state.openLesson = nextLessonIndex(books[0], getStorage());
      }
      updateMentorStatus();
    }

    function updateMentorStatus() {
      const title = root.querySelector('[data-mentor-status-title]');
      const copy = root.querySelector('[data-mentor-status-copy]');
      const balance = root.querySelector('[data-credit-balance]');
      if (!title || !copy || !balance) return;

      if (!state.remoteReady) {
        title.textContent = 'A Mentor kapcsolódik';
        copy.textContent = 'Betöltjük a haladásodat és a válaszaidat.';
        balance.textContent = '— kredit';
        return;
      }

      const credits = Number(state.bootstrap?.dailyRemaining || 0) + Number(state.bootstrap?.bonusRemaining || 0);
      balance.textContent = `${credits} kredit`;
      if (isMentorActive()) {
        title.textContent = 'A Mentor naprakész';
        copy.textContent = 'Látja a haladásodat és a válaszaidat.';
      } else {
        title.textContent = 'A Mentor jelenleg inaktív';
        copy.textContent = 'Az e-bookjaid és a mentett válaszaid továbbra is elérhetők.';
      }
    }

    function updateCreditLinks() {
      const urls = state.bootstrap?.checkoutUrls || {};
      const byAmount = {
        10: urls.credit10,
        30: urls.credit30,
        100: urls.credit100
      };

      root.querySelectorAll('[data-credit-pack]').forEach(link => {
        const url = byAmount[Number(link.dataset.creditPack)];
        if (url) {
          link.href = url;
          link.removeAttribute('aria-disabled');
          link.removeAttribute('data-unavailable');
        } else {
          link.href = '#';
          link.setAttribute('aria-disabled', 'true');
          link.setAttribute('data-unavailable', '');
        }
      });
    }

    function bindGlobal() {
      root.querySelector('[data-back-library]')?.addEventListener('click', () => {
        reader?.setAttribute('hidden', '');
        libraryHome?.removeAttribute('hidden');
        window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
      });

      root.querySelectorAll('[data-credit-pack]').forEach(link => {
        link.addEventListener('click', event => {
          if (link.getAttribute('aria-disabled') === 'true') event.preventDefault();
        });
      });

      root.querySelectorAll('[data-open-mentor]').forEach(btn => {
        btn.addEventListener('click', () => openMentor(state.openLesson || 0));
      });

      root.querySelectorAll('[data-close-mentor]').forEach(btn => {
        btn.addEventListener('click', closeMentor);
      });

      root.querySelector('[data-mentor-form]')?.addEventListener('submit', event => {
        event.preventDefault();
        const input = root.querySelector('[data-mentor-input]');
        const text = input?.value.trim();
        if (!text) return;
        addMentorMessage('user', text);
        if (input) input.value = '';
        if (!state.session?.token) {
          addMentorMessage('mentor', 'A Mentor használatához először jelentkezz be a könyvtáradba.');
          return;
        }
        const book = visibleBooks().find(item => item.id === state.activeBook) || visibleBooks()[0] || BOOKS[0];
        const lesson = book.lessons[state.openLesson] || book.lessons[0];
        const contextPrefix = lesson
          ? `Aktuális e-book: ${book.title}. Aktuális rész: ${state.openLesson + 1}. ${book.unitLabel} – ${lesson.title}.`
          : `Aktuális e-book: ${book.title}.`;
        const pending = addMentorMessage('mentor', 'Írom a választ…');
        platformApi('/ai/chat', {
          method: 'POST',
          body: {
            message: `${contextPrefix}\n\nFelhasználói kérdés: ${text}`,
            lessonDay: Math.max(1, Math.min(7, (state.openLesson || 0) + 1)),
            mode: 'lesson_help'
          }
        }).then((data) => {
          if (pending) pending.remove();
          if (state.bootstrap) {
            if (Number.isFinite(Number(data.dailyRemaining))) state.bootstrap.dailyRemaining = Number(data.dailyRemaining);
            if (Number.isFinite(Number(data.bonusRemaining))) state.bootstrap.bonusRemaining = Number(data.bonusRemaining);
            updateMentorStatus();
          }
          addMentorMessage('mentor', data.reply || 'Most nem kaptam választ a Mentortól. Próbáld újra.');
        }).catch((error) => {
          if (pending) pending.remove();
          addMentorMessage('mentor', error.message || 'Most nem sikerült kapcsolódni a Mentorhoz.');
        });
      });
    }

    function openMentor(lessonIndex) {
      state.openLesson = Number.isFinite(lessonIndex) ? lessonIndex : state.openLesson;
      updateMentorContext();
      root.querySelector('[data-mentor-drawer]')?.removeAttribute('hidden');
      setTimeout(() => root.querySelector('[data-mentor-input]')?.focus(), 80);
    }

    function closeMentor() {
      root.querySelector('[data-mentor-drawer]')?.setAttribute('hidden', '');
    }

    function updateMentorContext() {
      const books = visibleBooks();
      const book = books.find(item => item.id === state.activeBook) || books[0] || BOOKS[0];
      const lesson = book.lessons[state.openLesson] || book.lessons[0];
      const text = lesson ? `${book.title} · ${state.openLesson + 1}. ${book.unitLabel} – ${lesson.title}` : book.title;
      setText('[data-mentor-context]', text);
    }

    function addMentorMessage(role, text) {
      const box = root.querySelector('[data-mentor-messages]');
      if (!box) return;
      const div = document.createElement('div');
      div.className = `spl-msg spl-msg--${role === 'user' ? 'user' : 'mentor'}`;
      div.innerHTML = role === 'user'
        ? `<p>${escapeHtml(text)}</p>`
        : `<span>S</span><p>${escapeHtml(text)}</p>`;
      box.appendChild(div);
      box.scrollTop = box.scrollHeight;
      return div;
    }

    function setText(selector, text) {
      const el = root.querySelector(selector);
      if (el) el.textContent = text || '';
    }

    function setHtml(selector, html) {
      const el = root.querySelector(selector);
      if (el) el.innerHTML = html || '';
    }
  }

  function escapeHtml(text) {
    return String(text || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }
})();
